module.exports = __webpack_public_path__ + "img/vigor_logo.5b3f9079.png";